import { call, put } from "redux-saga/effects";
import { settingConstants } from "../actions/constants/settingConstant";
import { exceptionHandler, exceptionHandlerForUpdate } from "../pages/common/functions";
import SettingService from "../services/api/settingService";

function* settingsGetList() {
    try {
        const result = yield call(SettingService.settingGetList);
        var res = exceptionHandler(result);
        if (res.status) {
            yield put({
                type: settingConstants.Setting_Get_Success,
                payload: res.data
            });
        } else {
            yield put({ type: settingConstants.Setting_Get_Failure, payload: res.data });
        }
    } catch (e) {
        yield put({ type: settingConstants.Setting_Get_Failure, payload: e });
    }
}

function* settingStatusUpdate(request: any) {
    try {
        const result = yield call(SettingService.settingStatusUpdate, request.input);
        const res = exceptionHandler(result)
        if (res.status) {
            yield put({ type: settingConstants.SettingStatusUpdateSuccess,	payload: res.data });
        }
        else {
            yield put({ type: settingConstants.SettingStatusUpdateFailure, payload: res.data });
        }
    }
    catch (e) {
        yield put({ type: settingConstants.SettingStatusUpdateFailure, payload: e });
    }
}

function* settingContentUpdate(input: any) {
    try {
        const result = yield call(SettingService.settingContentUpdate, input.input);
        const res = exceptionHandlerForUpdate(result)
        if (res.status) {
            yield put({ type: settingConstants.SettingContentUpdateSuccess, payload: res.data });
        }
        else {
            yield put({ type: settingConstants.SettingContentUpdateFailure, payload: res.data });
        }
    }
    catch (e) {
        yield put({ type: settingConstants.SettingContentUpdateFailure, payload: e });
    }
}

function* getSettingContent(input: any) {
    try {
        const result = yield call(SettingService.getSettingContent, input.input);
        const res = exceptionHandler(result)
        if (res.status) {
            yield put({ type: settingConstants.GetSettingContentSuccess, payload: res.data });
        }
        else {
            yield put({ type: settingConstants.GetSettingContentFailure, payload: res.data });
        }
    }
    catch (e) {
        yield put({ type: settingConstants.GetSettingContentFailure, payload: e });
    }
}


export const settingSaga = {
    settingsGetList,
    settingStatusUpdate,
    settingContentUpdate,
    getSettingContent
}